module.exports = __webpack_public_path__ + "img/alternate-facebook-icon.3742d6b6.svg";